import React, { useState, useEffect } from 'react'
import { url } from "../../../App";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import Backdrop from "@mui/material/Backdrop";
import { useNavigate } from "react-router";
import CircularProgress from "@mui/material/CircularProgress";
import Cookies from 'js-cookie';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

import { Line } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const LineChart = () => {
  const [BL, setBL] = useState([])
  const [LAP, setLAP] = useState([])
  const [diary, setdiary] = useState([])
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  const token = Cookies.get('Token');
  const email = Cookies.get('Email');
  const [dateList, setDateList] = useState([]);
  const [visible, setvisible] = useState(false);
  const [dailyDashboardVisible, setdailyDashboardVisible] = useState(false);

  useEffect(() => {

    if (email === "rupesh.bishnoi@credin.in") {
      setvisible(true);
    }
    else {
      axios
    .post(url + "/user/getsingle", {
      token: token,
      email: email,
      useremail:email
    })
    .then((res) => {
       if (res.data.logout === true) {
        toast.error(res.data.message);
        setTimeout(() => {
         navigate("/");
      }, 3000);
     } 
     else{
        setdailyDashboardVisible(res.data[0].permission.dashboard_daily);
        setvisible(false);
    }
    })
    .catch((err) => {
      // console.log(err);
    })};

    const dates = [];
    let fromDate = new Date(new Date().setDate(1))
    let toDate = new Date();

    while (fromDate <= toDate) {
      dates.push(new Date(fromDate));
      fromDate.setDate(fromDate.getDate() + 1);
    }
    setDateList(dates);

    setOpen(true);
    axios
      .post(url + "/dashboard/loan",{
        email: email,
        token: token,
      })
      .then((res) => {
        setOpen(false);
        setBL(res?.data.BL);
        setLAP(res?.data.LAP);
        setdiary(res?.data.diary);
      })
      .catch((err) => {
        // console.log(err);
        toast.error(err.message);
      });
  }, [email, token,navigate]);

  var data = {
     labels: dateList?.map((date,index) => `Day ${index+1}`),
    //  labels: dateList?.map((date,index) => `Day ${index+1}: ${date.toLocaleDateString()}`),
    datasets: [
      {
        label: `LAP`,
        // data: [1, 2, 1, 0, 5, 1, 2, 1, 1, 4, 0, 2],
        data:LAP,
        fill: false,
        backgroundColor: '#5B9BD5',
        borderColor: '#5B9BD5',
        tension: 0.3,
      },
      {
        label: `Dairy`,
        // data: [2, 5, 8, 4, 6, 9, 1, 0, 3, 8, 11, 4],
        data:diary,
        fill: false,
        backgroundColor: '#ED7D31',
        borderColor: '#ED7D31',
        tension: 0.3,
      },
      {
        label: `BL`,
        // data: [3, 0, 1, 5, 7, 2, 8, 2, 9, 4, 3, 0],
        data:BL,
        fill: false,
        backgroundColor: '#A5A5A5',
        borderColor: '#A5A5A5',
        tension: 0.3,
      },
    ]
  };
  let temp = BL?.concat(diary)?.concat(LAP)
  let maxNumber = temp ? Math.max(...temp) :"";
  var options = {
    maintainAspectRatio: false,
    responsive:true,
    scales: {
      y: {
          min: 0,
          max: maxNumber+1,
          ticks: {
            stepSize: 1
          }
      }
  },
    legend: {
      labels: {
        fontSize: 25,
      },
    },
  }

  return (
    <div>
     {(dailyDashboardVisible || visible) && (
      <Line
        data={data}
        height={400}
        options={options}
      />
      )}
      <ToastContainer />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}

export default LineChart